import { render, staticRenderFns } from "./EntityTableCard.vue?vue&type=template&id=74a86619&scoped=true&lang=pug&"
import script from "./EntityTableCard.vue?vue&type=script&lang=ts&"
export * from "./EntityTableCard.vue?vue&type=script&lang=ts&"
import style0 from "./EntityTableCard.vue?vue&type=style&index=0&id=74a86619&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a86619",
  null
  
)

export default component.exports